document.addEventListener("DOMContentLoaded", function () {

  /* =============================================
     ACCORDION – smooth animation fix
     Native <details> jumps to open instantly.
     We intercept the toggle, cancel it, then
     animate via the grid-template-rows trick.
  ============================================= */
  document.querySelectorAll(".cr-accordion").forEach(function (details) {

    var summary = details.querySelector(".cr-accordion__summary");

    summary.addEventListener("click", function (e) {
      e.preventDefault();

      if (details.open) {
        /* Closing: animate first, then remove [open] */
        details.querySelector(".cr-accordion__body").style.gridTemplateRows = "0fr";
        setTimeout(function () {
          details.removeAttribute("open");
        }, 350); /* match CSS transition duration */
      } else {
        /* Opening: set [open] first, then animate in */
        details.setAttribute("open", "");
        /* Force reflow so the browser registers the open state */
        details.querySelector(".cr-accordion__body").offsetHeight;
        details.querySelector(".cr-accordion__body").style.gridTemplateRows = "1fr";
      }
    });
  });


  /* =============================================
     MODAL – open on "Check Report" button click
  ============================================= */
  var modal      = document.getElementById("clinical-report-modal");
  if (!modal) return;

  var modalImage = modal.querySelector(".clinical-modal-image");
  var closeBtn   = modal.querySelector(".clinical-close");
  var overlay    = modal.querySelector(".clinical-modal-overlay");

  document.querySelectorAll(".cr-check-btn").forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      var imageUrl = this.getAttribute("data-report");
      if (!imageUrl) return;

      modalImage.src = "";
      modal.classList.add("active");
      document.body.classList.add("modal-open");
      var stickyBar = document.querySelector(".product-sticky-bar");
      if (stickyBar) stickyBar.style.display = "none";
      modal.querySelector(".clinical-modal-container").scrollTop = 0;
      modalImage.src = imageUrl;
    });
  });

  function closeModal() {
    modal.classList.remove("active");
    document.body.classList.remove("modal-open");
    var stickyBar = document.querySelector(".product-sticky-bar");
    if (stickyBar) stickyBar.style.display = "";
    setTimeout(function () { modalImage.src = ""; }, 200);
  }

  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("active")) closeModal();
  });

});